module.exports = __webpack_public_path__ + "static/media/cars_footer@2x.4d59aa8e.png";